module.exports = __webpack_public_path__ + "img/ring.30f6dfd5.jpg";